import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class UserNotificationService extends AbstractService {

	static userNotificationSettingsApi = NexusService.userNotificationSettingsApi;

	static getNotificationSettings() {
		return this.userNotificationSettingsApi.getUserNotificationSettings().then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}

	static updateNotificationSettings(data) {
		const updateReqest = {
			userNotificationSettingUpdatePayload: data.map(item => ({
				GroupType: item.GroupType,
				NotificationMethods: item.NotificationMethods.map(method => ({
					MethodType: method.MethodType,
					MethodName: method.MethodName,
					Customizable: method.Customizable,
					Enabled: method.Enabled,
				})),
			})),
		};
		return this.userNotificationSettingsApi
			.updateUserNotificationSettings(updateReqest)
			.then(response => {
				const apiResponse = {
					data: response,
				};

				return apiResponse;
			});
	}

	static getNotifications(queryParams, getCancelToken) {
		return this.get({
			getCancelToken,
			queryParams,
			endpoint: `${ENDPOINTS.users}/${ENDPOINTS.pushNotifications}`,
		});
	}

	static setNotificationsAsRead(data) {
		return this.put({
			endpoint: `${ENDPOINTS.users}/${ENDPOINTS.pushNotifications}/read`,
			data,
		});
	}
}
